import React from 'react';
import { RootStack } from 'src/navigation/RootNavigation';
import withScreenErrorBoundary from 'src/navigation/withScreenErrorBoundary';
import withSuspense from 'src/navigation/withSuspense';
import AnswerHistoryScreen from './screens/AnswerHistory';
import HomeScreen from './screens/Home';
import NoteViewerScreen from './screens/NoteViewer';
import QPScreen from './screens/QP';
import QuestionScreen from './screens/Question';
import QuestionSearchScreen from './screens/QuestionSearch';
import SubjectScreen from './screens/Subject';
import TopicQuestionsScreen from './screens/TopicQuestions';
const Home = withScreenErrorBoundary(HomeScreen);
const Subject = withScreenErrorBoundary(SubjectScreen);
const TopicQuestions = withScreenErrorBoundary(TopicQuestionsScreen);
const QP = withScreenErrorBoundary(QPScreen);
const Question = withScreenErrorBoundary(QuestionScreen);
const AnswerHistory = withScreenErrorBoundary(AnswerHistoryScreen);
const QuestionSearch = withScreenErrorBoundary(QuestionSearchScreen);
const NoteViewer = withScreenErrorBoundary(NoteViewerScreen);
const NoteEditor = withSuspense(React.lazy(() => import('./screens/NoteEditor')));
export const renderExamPreparationStackRoutes = ({}) => {
    return (React.createElement(RootStack.Group, null,
        React.createElement(RootStack.Screen, { name: "EP_Home", component: Home }),
        React.createElement(RootStack.Screen, { name: "EP_Subject", component: Subject }),
        React.createElement(RootStack.Screen, { name: "EP_TopicQuestions", component: TopicQuestions }),
        React.createElement(RootStack.Screen, { name: "EP_QP", component: QP }),
        React.createElement(RootStack.Screen, { name: "EP_Question", component: Question }),
        React.createElement(RootStack.Screen, { name: "EP_AnswerHistory", component: AnswerHistory }),
        React.createElement(RootStack.Screen, { name: "EP_QuestionSearch", component: QuestionSearch }),
        React.createElement(RootStack.Screen, { name: "EP_NoteViewer", component: NoteViewer }),
        React.createElement(RootStack.Screen, { name: "EP_NoteEditor", component: NoteEditor })));
};
